import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../store/auth";

export default function ProtectedRoute({ roles = [] }) {
  const { user, checkAuth, loading, isLoggingOut,logout } = useAuth();
  const [checked, setChecked] = useState(false);

  useEffect(() => {

   // console.log("isLoggingOut", isLoggingOut);
    if (isLoggingOut) return; // 🚫 NIE sprawdzaj w trakcie wylogowania

     function verify() {
      if (!user) {
         checkAuth();
      }
      setChecked(true);
    }

    verify();
  }, [user, checkAuth, isLoggingOut]);

  if (!checked || loading) return <div>Ładowanie...</div>;

  if (!user) return <Navigate to="/login" replace />;
if (user.role === "") {

  logout();
 
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
